import { Button, Label } from "reactstrap";
import PreviewForm from "../../formBuilder/previewForm";
import { useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function ViewForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state?.data || {};
    const formData = JSON.parse(data?.formFields || '[]')
    const formRef = useRef(null)

    
    const handleSubmit = (e) => {
      e.preventDefault();
      const { isValid } = formRef.current?.validate() || { isValid: false };
      if (!isValid) {
        // Optionally scroll to first error
        const firstErr = document.querySelector(".invalid-feedback.d-block, .is-invalid");
        if (firstErr) firstErr.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      const values = formRef.current?.getValues() || {};
      console.log("SUBMIT VALUES:", values);
      // ... proceed (API call, etc.)
    };

    return (
      <div className="container" style={{ display: "flex", flexDirection: "column" ,backgroundColor: "#fff", minHeight: "75vh"}}>
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0.75rem 1.5rem",
            borderBottom: "1px solid #dee2e6",
            flexShrink: 0,
          }}
        >
          <h5 className="mb-0">View Form</h5>
          <button className="btn btn-sm btn-outline-secondary" onClick={() => navigate(-1)}>
            &times; Close
          </button>
        </div>

        {/* Body — scrollable */}
        <div style={{ flex: 1, overflowY: "auto", padding: "1rem 1.5rem" }}>
          <Label>Form Name:</Label>
          <p>{data?.name ?? "-"}</p>

          <Label>Form Preview:</Label>
          <form onSubmit={handleSubmit} style={{display:"flex",flexDirection:"column",justifyContent:"space-between",height:"100%"}}>
            <PreviewForm ref={formRef} grid={formData} type={"form"} json={data?.json} />
            <div className="w-full">
              <Button
                type="submit"
                className="mx-auto w-full block"
                style={{ maxWidth: 200, display: "block", marginTop: "20px" }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    )
}